/**
 * Convert a kebab-case template slug to camelCase, used as the UILM
 * `moduleName` for that template. Template slugs are already validated as
 * `[a-z0-9-]+` so this is a closed transformation — no edge cases beyond
 * empty strings.
 *
 *   nda                  → nda
 *   employment-agreement → employmentAgreement
 *   student-agreement-v2 → studentAgreementV2
 */
export function slugToCamelCase(slug: string): string {
  return slug
    .toLowerCase()
    .split('-')
    .filter(Boolean)
    .map((part, i) => (i === 0 ? part : part.charAt(0).toUpperCase() + part.slice(1)))
    .join('');
}
